var initialEnvironment = function () {
    function defaultProcess() {
        $('.envs_area').eq(0).click();

        return true;
    }

    // Fragment doesn't exist
    if (!window.location.hash) {
        return defaultProcess();
    }

    var sid = window.location.hash.split('#')[1];

    if (!RegExp('^[0-9]+$', 'g').test(sid)) {
        return defaultProcess();
    }

    // Fragment exists
    var target = $('[data-sid="' + sid + '"]');

    $('[data-env-cat-sid="' + target.data('category-sid') + '"]').click();

    target.click();

    $('html, body').animate({
        scrollTop: ($(`#${sid}`).offset().top - 100)
    }, 700);
};

var buildEnvironmentSwitchTrigger = function () {
    $('.envs_area').click(function (e) {
        var self = $(this);

        $('.envs_area').removeClass('active');
        self.addClass('active');

        $('.envs__block').hide();
        $('.envs__block[data-category="' + self.data('name') + '"]').show();
    });

    initialEnvironment();
};

$(function () {
    $('.expand__target').each(function () {
        $(this).css('max-height', this.scrollHeight + 'px');
    });

    buildEnvironmentSwitchTrigger();
});
